import React from 'react'
import SimpleBarReact from "simplebar-react";
import './scrollbar.scss'

const Scrollbar = ({children,...others}) => {
    return (
        <SimpleBarReact forceVisible="y" autoHide={false} {...others}>
        {children}
      </SimpleBarReact>
    )
}

export default Scrollbar
